import type { EdgeId, NodeSn } from '@ipfabric/utils';
import type {
  DeviceExplorerEdgeData,
  NodeDetailArgs,
} from 'components/DeviceView/deviceViewTypes';
import { getDeviceViewEntityEdgeId } from 'components/DeviceView/helpers/getDeviceViewEntityEdgeId';
import { getDeviceViewEntityNodeId } from 'components/DeviceView/helpers/getDeviceViewEntityNodeId';
import type { DeviceViewCommandFactory } from '../DeviceViewModel';
import { closeDeviceViewEntity } from './closeDeviceViewEntity';

interface RefreshDeviceViewEntityIdsCommand {
  deviceSns: NodeSn[];
  edgeIds: EdgeId[];
  updatedEdgeData: Map<EdgeId, DeviceExplorerEdgeData>;
  updatedNodeData: Map<NodeSn, NodeDetailArgs>;
}

export const refreshDeviceViewEntityIds: DeviceViewCommandFactory<
  RefreshDeviceViewEntityIdsCommand
> = (cmdContext, dispatch) => (command) => {
  for (const entity of cmdContext.getState().deviceViewEntities) {
    if (
      entity.deviceViewElement === 'edge' &&
      !command.edgeIds.includes(entity.edgeId)
    ) {
      dispatch(closeDeviceViewEntity, { deviceViewEntityId: entity.id });
    }
    if (
      entity.deviceViewElement === 'node' &&
      !command.deviceSns.includes(entity.sn)
    ) {
      dispatch(closeDeviceViewEntity, { deviceViewEntityId: entity.id });
    }
    if (
      entity.deviceViewElement === 'labels' ||
      entity.deviceViewElement === 'packetDetails' ||
      entity.deviceViewElement === 'pathlookupDebug'
    ) {
      dispatch(closeDeviceViewEntity, { deviceViewEntityId: entity.id });
    }
  }

  // biome-ignore lint/complexity/noExcessiveCognitiveComplexity: TBD eventually cleanup
  cmdContext.updateState((draft) => {
    const { activeDeviceViewEntityId } = draft;
    for (const deviceViewEntity of draft.deviceViewEntities) {
      if (
        deviceViewEntity.deviceViewElement === 'node' &&
        command.updatedNodeData.has(deviceViewEntity.sn)
      ) {
        const nodeData = command.updatedNodeData.get(deviceViewEntity.sn);
        if (nodeData !== undefined) {
          if (activeDeviceViewEntityId === deviceViewEntity.id) {
            draft.activeDeviceViewEntityId = getDeviceViewEntityNodeId(
              nodeData.sn,
            );
          }
          Object.assign(deviceViewEntity, nodeData);
        }
      } else if (
        deviceViewEntity.deviceViewElement === 'edge' &&
        command.updatedEdgeData.has(deviceViewEntity.edgeId)
      ) {
        const edgeData = command.updatedEdgeData.get(deviceViewEntity.edgeId);
        if (edgeData !== undefined) {
          const newEntityId = getDeviceViewEntityEdgeId(
            deviceViewEntity.edgeId,
          );
          if (activeDeviceViewEntityId === newEntityId) {
            draft.activeDeviceViewEntityId = newEntityId;
          }
          Object.assign(deviceViewEntity, edgeData, { id: newEntityId });
        }
      }
    }
  });
};
